import { KV } from '../common/constant';
import qs from 'querystringify';
import { generateSign, getSignType } from '../shared/aut';
import log from 'loglevel';
export default class Http {
  constructor(store) {
    this.store = store;
    this.e = {
      error: this._onError.bind(this),
      timeout: this._onTimeout.bind(this),
      onload: this._onLoad.bind(this),
      onLoadend: this._onLoadend.bind(this)
    };
    this.xhr = new XMLHttpRequest();
    try {
      // IE, 不支持赋值
      this.xhr.responseType = 'json';
      this.xhr.timeout = 10000;
    } catch (e) {}
    this.xhr.onerror = this.e.error;
    this.xhr.ontimeout = this.e.timeout;
    this.xhr.onload = this.e.onload;
    this.xhr.onloadend = this.e.onLoadend;

    this.onError = null;
    this.onLoad = null;
    this.onLoadend = null;
    this.onTimeout = null;

    // 优先使用初始化传进来的[接口服务前缀]，没有传则使用配置的
    this.API_SERVER = this.store.getKV(KV.API_SERVER) || process.env.API_SERVER;
  }

  /**
   * inner method
   *
   * @param {*} e
   * @memberof Http
   */
  _onError(e) {
    this.onError && this.onError(e?.target?.response ?? e);
    this.onError = null;
  }

  /**
   * inner method
   *
   * @param {*} e
   * @memberof Http
   */
  _onLoad(e) {
    if (!e.target) {
      this._onError(e);
      return;
    }

    let response = e.target.response;
    // IE, 由于未赋值responseType为JSON，故手动解析
    if (typeof response === 'string') {
      try {
        response = JSON.parse(response);
      } catch (error) {
        response = e.target.response;
      }
    }
    // console.log(response)

    let { code } = response;
    if (+code !== 200) {
      this._onError(e);
      return;
    }

    this.onLoad && this.onLoad(response);
    this.onLoad = null;
  }

  /**
   * inner method
   *
   * @param {*} e
   * @memberof Http
   */
  _onLoadend(e) {
    this.onLoadend && this.onLoadend(e.target);
    this.onLoadend = null;
  }

  /**
   * inner method
   *
   * @param {*} e
   * @memberof Http
   */
  _onTimeout(e) {
    this.onTimeout && this.onTimeout(e);
    this.onTimeout = null;
  }

  post(apiURL, query, data) {
    data = data || {};
    const self = this;
    let url = apiURL.slice(0, 4).toLocaleLowerCase() === 'http' ? apiURL : this.API_SERVER + apiURL;
    if (query) url += qs.stringify(query, true);
    data[KV.CLIENT] = this.store.getKV(KV.CLIENT);
    data[KV.APP_ID] = this.store.getKV(KV.APP_ID);
    data[KV.THIRD_PARTY_USER_ID] = this.store.getKV(KV.THIRD_PARTY_USER_ID);
    data[KV.ACCESS_TOKEN] = this.store.getKV(KV.ACCESS_TOKEN);
    data[KV.PACKAGE_CHECK] = this.store.getKV(KV.PACKAGE_CHECK);

    this._appendSign(url, data); // 增加签名处理

    return new Promise((resolve, reject) => {
      self.onError = reject;
      self.onLoad = resolve;
      self.onTimeout = reject;
      self.xhr.open('POST', url);
      self.xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      self.xhr.send(qs.stringify(data));
    });
  }

  /**
   * HTTP模块销毁
   *
   * @memberof Http
   */
  destroy() {
    if (!this.xhr) {
      return;
    }

    this.xhr.onerror = null;
    this.xhr.onload = null;
    this.xhr.onloadend = null;
    this.xhr.ontimeout = null;
    this.xhr = null;

    this.onLoad = null;
    this.onLoadend = null;
    this.onTimeout = null;
    this.onError = null;
  }

  _appendSign(url, data) {
    /* prettier-ignore */
    const matches = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/.exec(url);
    const pathname = matches[5] || '';
    const apiEndName = pathname.substring(pathname.lastIndexOf('/') + 1);
    if (apiEndName.startsWith('s-')) {
      // s-开头的api, 增加签名
      data['signed_at'] = Date.now();
      data['sign_type'] = getSignType();
      const sign = generateSign(data);
      if (sign) {
        data['sign'] = sign;
        log.info('sign:', sign);
      }
    }
  }
}
